/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * BreadcrumbNameContext
 * ---------------------
 * Provides React context and hooks to manage display names for tables across the application.
 *
 * Responsibilities:
 *  - Stores a mapping from table names to their corresponding user-friendly display names.
 *  - Offers a context provider component to wrap the app or relevant subtree.
 *  - Provides a custom hook to access and update the table display names within components.
 *
 * Usage:
 *  - Wrap your app with <BreadcrumbNameProvider> to make display names accessible.
 *  - Call useBreadcrumbNames() inside components to get and set display name mappings.
 */

import React, { createContext, useContext, useState } from 'react';

// Context to hold mapping of tableName to displayName
const BreadcrumbNameContext = createContext({});

export function BreadcrumbNameProvider({ children }) {
  const [tableDisplayNames, setTableDisplayNames] = useState({});

  return (
    <BreadcrumbNameContext.Provider value={{ tableDisplayNames, setTableDisplayNames }}>
      {children}
    </BreadcrumbNameContext.Provider>
  );
}

export function useBreadcrumbNames() {
  return useContext(BreadcrumbNameContext);
}
